export default {
  metadata: {
    version: 1.0,
    langTag: 'en',
    langFamily: 'English',
    langVariant: 'American English',
    supportedLanguages: ['English', 'French'],
  },
  langText: {
    newUserInquiry: 'New user?',
    signupLink: 'Sign up',
    contactSupport: 'Contact support',
    rightReserved: 'All rights reserved © 2021 SeamID',
    privacyTerm: 'Privacy | Terms',
    appName: 'SeamID',
    organizationName: 'SEAMFIX',
    carouselHeader1: 'The Banana You Love',
    carouselHeader2: 'Mickey mouse always smile',
    carouselHeader3: 'Mickey and Friends',
    carouselText1: 'hey remember when we talked about some good banana',
    carouselText2: 'since the day I met mickey mouse I have always smiled',
    carouselText3: 'This is my friends we all have some amaizing time everyday',
    signinText: 'Sign In',
    loginConfigEmailAddressLabelKey: 'Enter Address',
    loginConfigEmailAddressPlaceholderKey: 'Enter Email Address',
    loginConfigEmailInvalidKey: 'Email is not valid',
    loginConfigEmailRequiredKey: 'Email is required',
    loginConfigEmailLengthKey:
      'Email length too short, must be 5 characters and above',

    loginConfigUsernameAddressLabelKey: 'Username',
    loginConfigUsernameAddressPlaceholderKey: 'Enter Username',
    loginConfigUsernameInvalidKey: 'Username is not valid',
    loginConfigUsernameRequiredKey: 'Username is required',
    loginConfigUsernameLengthKey:
      'Username length too short, must be 2 characters and above',
    loginConfigPhoneAddressLabelKey: 'Phone Number',
    loginConfigPhoneAddressPlaceholderKey: 'Enter Phone Number',
    loginConfigPhoneInvalidKey: 'Phone Number is not valid',
    loginConfigPhoneRequiredKey: 'PhoneNumber is required',
    loginConfigPhoneLengthKey:
      'Phone number is not valid must be 11 digits long',
    loginConfigPhoneMaxLengthKey:
      'PhoneNumber length too short, must be 13 numbers and above',

    loginConfigPasswordLabelKey: 'Password',
    loginConfigPasswordsPlaceholderKey: 'Enter Password',
    loginConfigPasswordInvalidKey: 'Password not valid',
    loginConfigPasswordRequiredKey: 'Password is required',
    loginConfigPasswordLengthKey:
      'Password length too short, must be 5 characters and above, include a special character and a number',
    forgotPasswordConfigPhoneLabelKey: 'Phone Number',
    forgotPasswordConfigPhonePlaceholderKey: 'Enter Phone number',
    forgotPasswordConfigPhoneInvalidKey: 'Phone number not valid',
    forgotPasswordConfigPhoneRequiredKey:
      'Your phone number is require for password reset',
    forgotPasswordConfigPhoneLengthKey:
      'Phone number is not valid must be 11 digits long',

    forgotPasswordEmailAddressLabelKey: 'Enter Address',
    forgotPasswordEmailAddressPlaceholderKey: 'Enter Email Address',
    forgotPasswordEmailInvalidKey: 'Email is not valid',
    forgotPasswordEmailRequiredKey: 'Email is required',
    forgotPasswordEmailLengthKey:
      'Email length too short, must be 5 characters and above',

    regexAtleastOneDigit: 'Password must contain at least one digit',
    regexAtLeastOneLowercase: 'Password must contain at least one lowercase',
    resetPasswordConfigPasswordLabelKey: 'Password',
    resetPasswordConfigPasswordPlaceholderKey: 'Enter Password',
    resetPasswordConfigPasswordInvalidKey: 'Password not valid',
    resetPasswordConfigPasswordRequiredKey:
      'Password is require for password reset',
    resetPasswordConfigPasswordLengthKey:
      'Password is not valid must be 11 digits long',

    resetPasswordFormSuccess: 'Password changed successfully',
    resetPasswordFormBackToSignIn: 'Back to sign in',
    resetPasswordFormHeader: 'Reset Password',
    resetPasswordFormSetPasswordText: 'Set your new password',
    resetPasswordFormBtnText: 'Reset Password',
    resetPasswordImageHeader: 'Time for a change',
    resetPasswordImageText: 'Create a new password for your account.',

    forgetPasswordHeaderText: 'Forgot Password',
    forgetPasswordEmailAddress:
      'Enter the email address associated with your account',
    forgetPasswordPhoneNumber:
      'Enter the phone number associated with your account',
    forgetPasswordAccount:
      'Enter the email or phone number associated with your account',
    forgetPasswordBtnText: 'Reset Password',
    forgetPasswordImageHeader: 'Drats!',
    forgetPasswordImageText:
      'Forgot your password? Quickly reset it by providing the your email.',

    changePasswordFormHeader: 'Change Password',
    changePasswordFormBtnText: 'Change Password',
    changePasswordFormSetPasswordText:
      'Change the default password sent to your email',

    resetLinkEmailHeader: 'Check your inbox',
    resetLinkPhoneHeader: 'Check your messages',
    resetLinkEmailMessage:
      'A password reset has been sent to the email address above. Please click the password reset link in  the email to set a new password',
    resetLinkPhoneMessage:
      'A password reset has been sent to the Phone number above. Please click the password reset link in  the message to set a new password',
    notYourEmail: 'Not your email?',
    notYourPhoneNumber: 'not your Phone Number',
    enterDifferentEmail: 'Enter different mail',
    enterDifferentPhoneNumber: 'Enter different Phone Number',
    needHelp: 'Need help?',

    resetOnLoginHeader: 'Time for a change',
    resetOnLoginEmailtext:
      'We’ve made some updates to our portal and you are required to change your password. A password reset link has been sent to the email address above.',
    resetOnLoginPhonetext:
      'We’ve made some updates to our portal and you are required to change your password. A password reset link has been sent to the phone number above.',
    gotoLogin: 'Goto Login',

    successBannerMessage: 'password is secure and all set!',

    socialGoogleText: 'Sign in with Google',
    welcomeBack: 'Welcome Back',
    signinToContinue: 'Sign in to continue',
    troubleSigninInquiry: 'Trouble signing in?',
    forgetText: 'Forgot Password?',
    otpConfirmBtn: 'Confirm OTP',
    otpHeader: 'Enter OTP',
    otpHeaderTextInit: 'We sent a ',
    otpHeaderTextFinal: 'digit confirmation code to',
    otpNotSeen: 'Haven’t received the OTP?',
    resendOtp: 'Send it again',
    emailIsRequired: 'Email is required',
    usernameIsRequired: 'Username is required',
    passwordIsRequired: 'Password is required',
    prefixIsRequired: 'is required',
    emailPatternMessage:
      'Only include characters a-z & A-Z, Numbers 0-9, Symbols fullstop (.) hyphen (-) and underscore(_) and characters not less than 2 before the @ in your email address',
    passwordPatternMessage:
      'Length of password should not be less than 6 characters. No space allowed',
    usernamePatternMessage:
      'Should only contain Alphabet, Numbers and dashes(-). No space allowed and at least 3 character',
    fillFieldWarning: 'Please fill out this field',

    createUserHeading: 'Create User',
    createUserHeadingText:
      'Create users to join you on Seamfix PaaS to collaborate on projects',
    createUserCheckboxtext: 'Create Another',
    createUserBtnText: 'Create',
    createUserConfigTitleLabelKey: 'Title',
    createUserConfigTitlePlaceholderKey: 'Title',
    createUserConfigTitleOptionKey1: 'Mr',
    createUserConfigTitleOptionKey2: 'Mrs',
    createUserConfigTitleOptionKey3: 'Miss',
    createUserConfigTitleRequiredKey: 'Title is required',
    createUserConfigFirstNameLabelKey: 'First Name',
    createUserConfigFirstNamePlaceholderKey: 'First Name',
    createUserConfigFirstNameRegexKey: 'First Name not valid',
    createUserConfigFirstNameRequiredKey: 'First Name is required',
    createUserConfigFirstNameLengthKey:
      'First Name length too short, must be 2 characters and above',
    createUserConfigFirstNameLengthKey2:
      'First Name length too Long, must not be more than 50 character',
    createUserConfigLastNameLabelKey: 'Last Name',
    createUserConfigLastNamePlaceholderKey: 'Last Name',
    createUserConfigLastNameRegexKey: 'Last Name not valid',
    createUserConfigLastNameRequiredKey: 'Last Name is required',
    createUserConfigLastNameLengthKey:
      'Last Name length too short, must be 2 characters and above',
    createUserConfigLastNameLengthKey2:
      'Last Name length too long, must not be more than 50 character',
    createUserConfigMiddleNameLabelKey: 'Middle Name',
    createUserConfigMiddleNamePlaceholderKey: 'Middle Name',
    createUserConfigMiddleNameRegexKey: 'Middle Name not valid',
    createUserConfigMiddleNameRequiredKey: 'Middle Name is required',
    createUserConfigMiddleNameLengthKey:
      'Middle Name length too short, must be 2 characters and above',
    createUserConfigMiddleNameLengthKey2:
      'Middle Name length too long, must not be more than 50 character',
    createUserConfigEmailLabelKey: 'Email Address',
    createUserConfigEmailPlaceholderKey: 'Email Address',
    createUserConfigEmailRegexKey: 'Email Address not valid',
    createUserConfigEmailRequiredKey: 'Email Address is required',
    createUserConfigEmailLengthKey:
      'Email Address length too short, must be 5 characters and above',
    createUserConfigGenderLabelKey: 'Gender',
    createUserConfigGenderPlaceholderKey: 'Gender',
    createUserConfigGenderOptionKey1: 'Male',
    createUserConfigGenderOptionKey2: 'Female',
    createUserConfigGenderOptionKey3: 'Neither',
    createUserConfigGenderRequiredKey: 'Gender is required',
    createUserConfigPhoneLabelKey: 'Phone Number',
    createUserConfigPhonePlaceholderKey: 'Enter Phone number',
    createUserConfigPhoneRegexKey: 'Phone number not valid',
    createUserConfigPhoneRequiredKey: 'Your phone number is required',
    createUserConfigPhoneLengthKey:
      'Phone number is not valid must be 9 digits long',
    createUserConfigPhoneLengthKey2:
      'Phone number must not be more than 11 digit',
    createUserConfigDateOfBirthLabelKey: 'Date of Birth',
    createUserConfigDateOfBirthPlaceholderKey: 'Date of Birth',
    createUserConfigDateOfBirthRequiredKey: 'Date of Birth is required',
    createUserConfigRoleLabelKey: 'Select Role',
    createUserConfigRolePlaceholderKey: 'Select Role',
    createUserConfigRoleOptionKey1: 'Administrator',
    createUserConfigRoleOptionKey2: 'Agent',
    createUserConfigRoleRequiredKey: 'Role is required',
    createUserConfigMessageLabelKey: 'Invite Message (Optioal)',
    createUserConfigMessagePlaceholderKey: 'Invite Message (Optioal)',
    createUserConfigMessageRequiredKey: 'Message is required',

    userManagementCreateBtnText: 'Create User',
    userManagementInviteBtnText: 'Invite Collaborators',
    userManagementTitleKey: 'Title',
    userManagementFirstNameKey: 'First name',
    userManagementLastNameKey: 'Last name',
    userManagementMiddleNameKey: 'Middle name',
    userManagementEmailKey: 'Email address',
    userManagementGenderKey: 'Gender',
    userManagementPhoneNumberKey: 'Phone number',
    userManagementDateOfBirthKey: 'Date of birth',
    userManagementRoleKey: 'Role',
    userManagementColumnText: 'Columns',
    userManagementColumnSelect: 'Select all',
    userManagementColumnUnselect: 'Unselect all',
    userManagementNavTitle: 'User Management',
    userManagementNavActiveText: 'active users',
    userManagementNavSearchPlaceholder: 'Search user management',
    userManagementNavSearchArial: 'Search',
    userManagementNavShowing: 'Showing',
    userManagementNavShowingOf: 'of',
    userManagementActiveNavFilterPlaceholder: 'Filter by user active status',
    userManagementLockedNavFilterPlaceholder: 'Filter by user locked status',
    userManagementLockedAccount: 'This account is locked',
    userManagementAccountNoEdit: "You can't edit role",
    userManagementChangeRole: 'Assigned Roles',
    userManageMentRoleDescriptionKey1:
      'This user has access to verify both IDs and their bearers using the iDQR verification app',
    userManageMentRoleDescriptionKey2:
      'This user has access to verify both IDs and their bearers using the iDQR verification app',
    userManageMentRoleDescriptionKey3:
      'This user has access to verify both IDs and their bearers using the iDQR verification app',
    userManagementOptionViewText: 'View details',
    userManagementOptionEditText: 'Edit user Details',
    userManagementOptionResetPasswordText: 'Reset password',
    userManagementOptionLockText: 'Lock user',
    userManagementOptionUnlockText: 'Unlock user',
    userManagementOptionDeactivateText: 'Deactivate',
    userManagementOptionActivateText: 'Activate',
    userManagementSerialHashKey: 'serial-hash-key',
    userManagementPortraitImageKey: 'Portrait image',
    userManagementStatusKey: 'Status',

    resetPasswordModalHeading: 'Reset Password',
    resetPasswordModalInfoText1: 'You are about to reset',
    resetPasswordModalInfoText2:
      'password. By reseting this password a new password is generated and sent to',
    resetPasswordModalInfoText3: 'email. Do you want to continue?',
    resetPasswordModalSubmitBtn: 'Reset Password',
    resetPasswordModalCancelBtn: 'Cancel',

    activateModalActivateText: 'Activate',
    activateModalDeactivateText: 'Deactivate',
    activateModalUserText: 'User',
    activateModalInfoText1: 'You are about to',
    activateModalInfoText2: 'Do you want to continue?',
    activateModalSubmitBtn: 'Activate',
    activateModalCancelBtn: 'Cancel',

    unlockModalHeading: 'Unlock User',
    unlockModalInfoText1: 'You are about to',
    unlockModalactionText: 'unlock',
    unlockModalInfoText2: 'Do you want to continue?',
    unlockModalSubmitBtn: 'Unlock',
    unlockModalCancelBtn: 'Cancel',

    viewUserModalDoneBtn: 'Close',

    userManagementBulkUploadBtnText: 'Bulk upload Users',

    gotAnAccount: 'Got an Account?',
    signinLink: 'Sign in',
    signupSocialGoogleText: 'Sign up with Google',
    getStarted: 'Get Started',
    getStartedTitle: 'Create your free account on Seamfix PaaS',
    troubleSignupInquiry: 'Trouble signing up?',
    signupButton: 'Get Started',

    userManagementNavInactiveText: 'inactive users',

    dashboardNavShowing: 'Showing',
    dashboardNavShowingOf: 'of',

    organisationManagementNavTitle: 'Organisation Management',
    organisationManagementNavSearchPlaceholder:
      'Search organisation management',
    organisationManagementNavSearchArial: 'Search',
    organisationManagementActiveNavFilterPlaceholder:
      'Filter by organisation status',
    organisationManagementCreateBtnText: 'Create Organisation',
    activateModalOrgText: 'Organisation',
    activateOrgModalInfoText1: 'You are about to',
    activateOrgModalInfoText2:
      'as an Organisation. Are you sure you want to continue?',
    optionModalApprove: 'Approve',
    optionModaldisApprove: 'Disapprove',
    optionModalContinueApprove: 'Do you want to continue',
    generalOptionEditText: 'Edit Details',
    generalOptionViewText: 'View details',
    generalOptionDeactivateText: 'Deactivate',
    generalOptionActivateText: 'Activate',
    totalOrgText: 'Total Organisation',
    activeOrgText: 'Active Organisation',
    inactiveOrgText: 'Inactive Organisation',
    orgViewDetailsHeader: 'Organisation Details',

    verifyMyOrganisationBtn: 'Verify My Organisation',
    proceedBtn: 'Proceed',
    goBackBtn: 'Go Back',
    nextBtn: 'Next',
    doneBtn: 'Done',

    dashboardNavigationText1: 'Dashboard',
    dashboardNavigationText2: 'Templates',
    dashboardNavigationText3: 'Organisation',
    dashboardNavigationText4: 'User',
    dashboardNavigationText5: 'Form Builder',
    dashboardNavigationText6: 'Wallet',
    dashboardNavigationText7: 'Branches',
    dashboardNavigationText15: 'Payer',
    dashboardNavigationText17: 'Payments',
    dashboardNavigationText18: 'Pay Bills',
    dashboardNavigationText19: 'Approval',
    homeReportManagementTranslationKey: 'Report',
    idCardsManagementTranslationKey: 'ID Cards',
    generatedIdCardsManagementTranslationKey: 'Bulk Generated ID Card',
    projectManagementTranslationKey: "Projects",
    adminUserManagementTranslationKey: "Users",

    unauthoriseHeader: 'Unauthorised access!',
    unauthoriseParagraph:
      'You do not have the required privilege to view this page',
    unauthoriseButtonText: 'Back to previous Page',

    dashboardSettingLogout: 'Logout',
    dashboardSwitchCommunity: 'Community',
    dashboardJoinCommunity: 'Join Community',

    dashboardSettingText1: 'Help',
    dashboardSettingText2: 'Account Settings',

    branchManagementNavTitle: 'Branch Management',
    branchManagementNavSearchPlaceholder: 'Search branch management',
    branchManagementNavSearchArial: 'Search',
    branchManagementActiveNavFilterPlaceholder:
      'Filter by branch active status',
    branchManagementCreateBtnText: 'Create Branch',

    activateModalBranchText: 'Branch',
    activateBtanchModalInfoText1: 'You are about to',
    activateBranchModalInfoText2:
      'as an Branch. Are you sure you want to continue?',
    branchViewDetailsHeader: 'Organisation Details',
    branchMetadataNavText: 'Branches',
    branchOptionalHeaderText: 'Users',
    branchManagementSubNavSearchPlaceholder:
      'Search using branch and manager name',

    generalBackButtonText: 'Back',

    profileDashboardUserTab: 'Personal Information',
    profileDashboardOrganisationTab: 'Business Information',
    profileDashboardSecurityTab: 'Security',
    profileDashboardUserHeader: 'Update your Personal Information',
    profileDashboardOrganisationHeader: 'Update your Business Information',
    profileDashboardSecurityHeader: 'Password',
    profileDashboardOTPBtn: 'Change Password',
    profileDashboardPasswordHeading: 'Change your password to a new one',
    profileDashboardBankTab: 'Bank Account',
    profileDashboardBankHeader: 'Bank Account Details',
    profileDashbaordErrorFetching: 'Error fetching banks',
    profileDashboardAccountCount: 'Bank Account',
    profileDashboardAddAccountBtn: 'Add Account',
    profileDashboardAccountSetup: 'You have no account set up',
    profileDashboardCreateAccount: 'Create Account',
    profileDashboardRemoveModalHeading: 'Remove Bank Account',
    profileDashboardRemoveModaltext: 'Are you sure you want to remove',
    profileDashboardRemoveModaltextList: 'from your account list',
    profileDashboardCancelBtn: 'Cancel',
    profileDashboardSubmitBtn: 'Submit',
    profileDashboardCreateModalHeading: 'Add account',
    profileDashboardEditModalHeading: 'Update account',
    profileDashboardCreateModaltext:
      'Enter bank account information where revenue will be payed.',
    profileDashboardSelectBank: 'Select Bank',
    profileDashboardInputAccountNumber: 'Account Number',
    profileDashboardInputAccountNumberPlaceholder: 'Enter account number',
    profileDashboardSelectPaymentGateway: 'Select Prefered Payment Gateway',
    profileDashboardCreateAnotherText: 'Create Another',
    profileDashboardUpdateBtn: 'Save Changes',
    profileDashbaordAccountNameValidation: 'Account verification failed.',
    profileDashbaordAccountNumberValidation: 'Account number is invalid',
    profileDashbaordAccountVerificationFailed:
      "We're unable to load the account creation page at this time. Please try again in 5 minutes",
    'serial-number-key': '#',
    'bank-name-key': 'BANK NAME',
    'bank-account-number-key': 'ACCOUNT NUMBER',
    'bank-account-name-key': 'ACCOUNT NAME',
    'bank-payment-gateway-key': 'PAYMENT GATEWAY',
    'bank-action-column-key': 'ACTION',
    'edit-action-key': 'Edit',
    'remove-action-key': 'Remove',

    supportedDashboardTypeUser: 'All Users',
    supportedDashboardTypeGroup: 'Groups',
    userGroupDashboardEmptyStateText:
      'Organise Your Users & Collection by Creating Groups',
    userGroupDashboardEmptyStateBtn: 'Create Group',
    userGroupDashboardCreateMemberError: 'Group Members cannot be empty',
    userGroupDashboardCreateHeader: 'Create User Group',
    userGroupDashboardEditHeader: 'Edit User Group',
    userGroupDashboardCreateNameInput: 'Group Name',
    userGroupDashboardCreateNameInputError: 'Invalid group name',
    userGroupDashboardSelectInput: 'Select Users ',
    userGroupDashboardCreateBtn: 'Create',
    userGroupDashboardCreateAnotherBtn: 'Create another',
    userGroupDashboardUpdateBtn: 'Save Changes',
    userGroupDashboardViewDetailsModalText: 'Users',
    userGroupDashboardViewDetailsModalHeaderName: 'Name',
    userGroupDashboardViewDetailsModalHeaderEmail: 'Email',
    userGroupDashboardViewDetailsModalRemoveUser: 'Remove User?',
    userGroupDashboardRemoveModalInfoText1: 'You are about to remove',
    userGroupDashboardRemoveModalInfoText2: 'from',
    userGroupDashboardRemoveModalInfoText3:
      'Are you sure you want to continue?',
    userGroupDashboardRemoveBtn: 'Remove',
    userGroupDashboardActivateHeader: 'Activate Group ?',
    userGroupDashboardDeactivateHeader: 'Deactivate Group ?',
    userGroupDashboardActivateModalInfoText1: 'You are about to ',
    userGroupDashboardActivateModalInfoText2:
      'Are you sure you want to continue?',

    bulkCreateUserTitle: 'User Bulk Upload',
    bulkCreateUserFirstDescPhrase: 'Bulk creating of multiple users involves',
    bulkCreateUserDownloading: 'downloading',
    bulkCreateUserSecondDescPhrase: 'the Structured Excel template,',
    bulkCreateUserPopulating: 'populating',
    bulkCreateUserThirdDescPhrase:
      'the downloaded template with the appropriate data, and',
    bulkCreateUserUploading: 'uploading',
    bulkCreateUserFourthDescPhrase: 'the completed template.',
    bulkCreateUserRedownload: 'Redownload',
    bulkCreateUserDonwload: 'Download',
    bulkCreateUserStructuredTemplate: 'structured excel template',
    bulkCreateUserDownloadInitiated: 'Download has been initiated',
    bulkCreateUserUploadTemplate: 'Upload populated excel template',
    bulkCreateUserFileSizeLimitMessage: 'File too large.',
    bulkCreateUserFileExtensionMessage: 'File extension not supported.',
    bulkCreateUserDelete: 'Delete',
    bulkCreateUserNext: 'Next',
    bulkCreateUserValidating: 'Validating',
    bulkCreateUserFixErrors: 'Fix all errors and reupload the excel file',
    bulkCreateUserErrors: 'Errors',
    bulkCreateUserError: 'Error',
    bulkCreateUserDetected: 'Detected',
    bulkCreateUserReuploadSheet: 'Re-upload Corrected Sheet',
    bulkCreateUserDownloadErrorSheet: 'Download Error Sheet',
    bulkCreateUserCancel: 'Cancel',
    bulkCreateUserNoErrors: 'No Errors Detected',
    bulkCreateUserDone: 'Done',

    roleManagementTitle: 'Role Management',
    roleCreateHeader: 'Create a Role',
    editRoleHeader: 'Edit Role',
    roleCreateBtn: 'Create Role',
    roleSubmitBtn: 'Submit',
    roleSaveChangesBtn: 'Save Changes',
    roleNavActiveText: 'Active Role(s)',
    roleNavInActiveText: 'InActive Role(s)',
    roleCreateAgainBtn: 'Create Again',
    roleOptionDeactivateText: 'Deactivate',
    roleOptionActivateText: 'Activate',
    roleNameHeader: 'Role Name',
    roleDescriptionHeader: 'Role Description',
    roleCreatedByHeader: 'Created By',
    roleActiveStatusHeader: 'Active Status',
    roleDateCreatedHeader: 'Date Created',
    rolePrivilegeHeader: 'Privilege(s)',
    roleViewDetailsVert: 'View Details',
    roleEditDetailsVert: 'Edit Details',
    roleActivateVert: 'Activate',
    roleDeactivateVert: 'Deactivate',
    roleFilterByActiveStatus: 'Filter by Active Status',
    roleFilterByOrganisation: 'Filter by Organisation',
    roleDownloadPlaceHolder: 'Download role list',
    roleSearchPlaceholder: 'Search using role name',
    roleInformation: 'Role Information',
    roleDateCreated: 'Date Created',
    roleDetails: 'Role Details',
    roleCloseBtn: 'Close',
    roleSelectPrivilege: 'Select Privilege(s)',
    roleSelectCommunity: 'Select Community',
    roleActivateModalHeaderText: 'this Role?',
    roleTotalHeader: 'Role(s)',
    roleActivateTextInfoEnd: 'role. Are you sure you want to continue?',
    roleDescriptionForm: 'Role Description (optional)',
    roleFilterByCommunity: 'Filter by Community',
    activeText: 'Active',
    inActiveText: 'InActive',
    allText: 'All',
    roleEmptyStateMain: 'No role to show',
    roleCreateAnother: 'Create Another',
    exportAsCSV: 'Export as CSV',
    exportAsExcel: 'Export as Excel',
    downloadRoleList: 'Download as Role List',
    roleCreateUnableToLoad:
      "We're unable to load the role creation page at this time. Please try again in 5 minutes",

    roleNameError: 'Please enter your role name',
    rolePrivilegesError: 'Please select one or more privileges',
    'datepicker-default-caption': 'ALL TIME',
    'datepicker-today-caption': 'Today',
    'datepicker-yesterday-caption': 'Yesterday',
    'datepicker-seven-days-caption': 'Last 7 Days',
    'datepicker-thirty-days-caption': 'Last 30 Days',
    'datepicker-last-month-caption': 'Last Month',
    'datepicker-custom-date-caption': 'Custom Range',
    'datepicker-apply-button': 'Apply',
    'datepicker-cancel-button': 'Cancel',

    'showing-text': 'Showing',
    of: 'of',
    newest: 'Newest',
    oldest: 'Oldest',
    show: 'Show',
    entries: 'Entries',

    roleInitViewMainText:
      'Easily control access on your organisation’s account by creating roles and privileges',
    roleInitViewSubText: 'Click the button below to create your first role',

    awMainHeading: 'Create your workflow',
    awSubHeading: 'Provide details that describes your workflow',
    awWorkflowNameLabel: 'Workflow Name',
    awWorkflowNamePlaceholder: 'Enter workflow name',
    awWorkflowDescriptionLabel: 'Short Description(Optional)',
    awWorkflowDescriptionPlaceholder: 'Short Description(Optional)',
    awLevelButtonText: 'Level',
    awWorkflowTypeHeading: 'What type of workflow do you want to create',
    awSimpleWorkflowType: 'A simple workflow',
    awSimpleWorkflowTootip:
      'Choose this option if you want to simply assign the approval of a request at this level to a person(s)',
    awConditionalWorkflowType: 'A conditional workflow',
    awConditionalWorkflowTootip:
      'Choose this option if the approval of a request at this level is dependent on a condition or a group of conditions',
    awValidationForLessAmount: 'Amount must be greater than',
    awValidationForApprovers: 'Select approvers',
    awValidationNoAMount: 'Enter an amount',
    awValidationInvalidAmount: 'Enter a valid amount',
    awValidationConditionConflict: 'Condition conflict',
    awValidationConditionConflictInRange: 'is in the range of',
    awValidationConditionConflictConjuction: 'and',
    awValidationForGreaterAmount: 'Amount must be less than',
    awValidationForDescription:
      'Field length must be within 4 and 220 characters',
    awValidationInvalidWorkflowName: 'Workflow name is required',
    awValidationShortDescriptionValue:
      'Field length too short, must be 5 characters and above',
    awMultiSelectPlaceholderIndividual: 'Select individual',
    awMultiSelectPlaceholderGroup: 'Select group',
    awMultiSelectPlaceholderBranch: 'Select type in branch',
    awAmountInputHeading: 'Amount',
    awAmountInputLable: 'Add Amount',
    awGreaterThanText: 'Greater than',
    awGreaterOrEqualtext: 'Greater than or equal to',
    awLessThanText: 'Less than',
    awLessOrEqualText: 'Less than or equal to',
    awAddRangeButtonText: 'Add Range',
    awCancelRangeButtonText: 'Cancel Range',
    awAddRangeConjustionText: 'AND',
    awWhoShouldApprove: 'Who should approve?',
    awApproverAsIndividual: 'Individuals',
    awApproverAsGroup: 'Groups',
    awApproverAsBranch: 'Branch',
    awApproverAsAuto: 'Auto Approve',
    awSingleApprovalText: 'Only one approver needs to approve the request',
    awMultipleApproverText:
      'Everyone assigned as an approver must approve the request',
    awConditionalFormHeading: 'Condition',
    awIfConditionHeading: 'If',
    awElseIfConditionHeading: 'Else If',
    awElseConditionHeading: 'Else',
    awAddConditionButtonText: 'Add Condition',
    awNavigationNext: 'Next',
    awNavigationPrevious: 'Previous',
    awAddMoreLevel: 'Add More Level',
    awCancelButtonText: 'Cancel',
    awCreateButtontext: 'Create',
    awCancelModalHeader: 'Cancel Workflow Creation',
    awCancelModalText:
      'You are about to cancel this workflow. If you continue all information will be lost',
    awContinueButtonText: 'Continue',
    awInitialStateHeading: 'Create & Define your Approval Workflow',
    awInitialStateSubHeading:
      'Approval workflow helps you create and manage various activities/processes that require an approval or a series of approvals before an action is taken',
    awInitialStateButtonText: 'Create Approval Workflow',
    awInitialStateDashboardHeading: 'Approval Management',

    loginConfigSelectType: 'Log in with your email or phone number',
    goBack: 'Go Back',
    otpSubHeaderText: 'Please input the One Time Password we sent to ',
    organisationManagementSubNavSearchPlaceholder:
      'Search using branch and manager name',
    dashboardNavigationText8: 'Transaction History',
    dashboardNavigationText9: 'Manual Wallet',
    dashboardNavigationText10: 'Invoice Management',
    dashboardNavigationText11: 'Reconciliation',
    dashboardNavigationText12: 'Revenue Types Management',
    dashboardNavigationText13: 'Role Management',
    dashboardNavigationText14: 'Demand Notice',
    dashboardNavigationText20: 'Wallet Management',
    dashboardNavigationText21: 'Base Manual Wallet',

    accountSettingHelptext: 'Help',
    accountSettingtext: 'Account Settings',
    accountSettingHelpSubtext: 'Account preferences and more',
    accountSettingSubtext: 'Help and support service',
    accountSettingBecomePayer: 'Become a payer',

    profileDashboardBrandingHeader: 'Themify your product to suit your brand',
    profileDashboardBrandingTab: 'Branding',

    'email-verification-token-expire':
      'This email verification link has expired. You can click the button below to resend a new verification link straight to your inbox',
    'email-verification-token-used':
      'This email verification link has already been used',
    'email-verification-token-invalid':
      'This email verification link has already been used',
    'email-verification-token-error':
      'An error occurred while verifying your email. Please click on the button below to resend a new verification link straight to your inbox',
    'email-verification-failed': 'EMAIL VERIFICATION FAILED',
    'having-trouble-verifying':
      'If you’re still having trouble verifying your email',
    'update-email-address': 'Update Email Address',
    'we-will-send-email':
      'We’ll send an email to you with a link to confirm your account',
    'send-confirmation-email': 'Send Confirmation Email',
    'email-address': 'Email Address',
    'email-verification': 'Email Verification',
    'to-confirm-account': 'to confirm your account',
    'if-you-get-a-mail':
      ' If you didn’t get a mail, it could be one of the following;',
    'in-your-spam': 'The email is in your spam folder',
    'email-had-typo': 'The email address you entered had a typo',
    'we-cant-deliver':
      'We can’t deliver to the email address usually because of corporate firewall or filtering',
    're-enter-email': 'Re-enter your email and try again',
    'resend-email-verification-link': 'Resend Email Verification Link',
    'signing-up-for': 'Who are you signing up for',
    myself: 'Myself',
    'an-organisation': 'An Organisation',
    continue: 'Continue',

    'reset-password-failed-heading': 'PASSWORD RESET FAILED',
    'reset-password-error-goto-login': 'Goto Login',
    'reset-password-invalid-link': 'This email verification link is invalid',
    'reset-password-expired-link':
      'The reset password link has expired. You can click the button below to resend a new reset password link to your email',
    'reset-password-error-occured':
      'An error occurred while processing your request. Please click on the link in your inbox to try again',

    baseAuthHeader1: 'Secure Offline ID Management. Simplified!',
    baseAuthHeader2: 'Get You Identity Delivered To You!',
    baseAuthSubText1:
      'You are in a good hand.',
    baseAuthSubText2:
      'Your data is secure.',
    fileByPaymentStatusKey: 'Filter by payment status',
    idManagementserialHashKey: 'serial-hash-key',
    idManagementPortraitImageKey: 'Portrait image',
    idManagementFirstNameKey: 'First name',
    idManagementLastNameKey: 'Last name',
    idManagementServiceKey: 'Service',
    idManagementRegistrationNumberKey: 'Registration Number',
    idManagementPaymentStatusKey: 'Payment Status',
    idManagementPrintStatusKey: 'Print Status',
    idManagementIssueStatusKey: 'Issue Status',
    idManagementRecaptureStatusKey: 'Recapture Status',
    idManagementStatusKey: 'Status',
    idManagementPrintCountKey: 'Print Count',
    idManagementRePrintCountKey: 'Re-Print Count',
    idManagementExpirationDateKey: 'Expiration Date',
    idManagementDateIssuedKey: 'Date Issued',
    idManagementDateGeneratedKey: 'Date Generated',
    bulkPrintIdCards: 'Bulk Print ID cards',
    bulkIssueIdCards: 'Bulk Issue Cards',
    
  },
};
